<style lang="scss">
.calls {}
</style>

<!-- eslint-disable -->
<template>
  <b-card no-body class="mb-0">
    <section>
      <b-table
        class="data-table"
        hover
        :items="calls"
        :fields="[...headers, {label: '', key: 'view'} ]"
        :current-page="currentPage"
        :per-page="0"
        :responsive="true"
      >
        <template #cell(created_at)="data">
          {{data.item.created_at | formatDateTime}}
        </template>

        <template #cell(view)="data">
          <b-btn variant="link" @click="$router.push({ name: 'call-details', params: { id: data.item._id } })">View</b-btn>
        </template>

        <template #cell(external_cancellation)="data">
          <input @change="$store.dispatch('callList/updateExternalCancellation', data.item)" v-model="data.item.external_cancellation" type="checkbox">
        </template>

        <template #cell(booked_by)="data">
          <p class="text-capitalize mb-0 pb-0">{{data.item.booked_by.toLowerCase() | term}}</p>
         </template>

        <template #cell(actions)="data">
          <b-dropdown class="m-0" variant="link" right toggle-class="text-decoration-none" no-caret>
            <template #button-content>
              <i class="fas fa-ellipsis-v"></i>
            </template>
            <b-dropdown-item-button v-if="actions.cancelled" class="full-nested-btn"
                                    @click="showModal('modal-cancel', true, data.item)">
              Cancel
            </b-dropdown-item-button>
            <b-dropdown-item-button v-if="actions.requested" class="full-nested-btn"
                                    @click="showModal('modal-reject', true, data.item)">
              Reject
            </b-dropdown-item-button>
          </b-dropdown>
         </template>

      </b-table>
      <b-row class="p-1">
        <b-col md="6" class="m-1" v-if="(totalRows > filters.limit) && totalRows !== 0">
          <b-pagination :total-rows="totalRows" :per-page="filters.limit" v-model="currentPage" class="my-0"/>
        </b-col>
        <p v-if="totalRows === 0" class="col-6 ml-2 my-1">No calls to show</p>
      </b-row>
    </section>

    <b-modal id="modal-cancel" hide-footer>
      <cancel-call @close="closeAllModalAndRefresh()" v-if="activeCall" :call="activeCall"></cancel-call>
    </b-modal>

    <b-modal id="modal-reject" hide-footer>
      <reject-call @close="closeAllModalAndRefresh()" v-if="activeCall" :call="activeCall"></reject-call>
    </b-modal>
  </b-card>
</template>
<!-- eslint-enable -->

<script>
import { mapState } from 'vuex';
import VisitService from '@/services/VisitService';
import { getVisitRequestedDates, getVisitBookedForDate } from '@/util/helpers';
import CancelCall from '@/components/calls/CancelCall';
import RejectCall from '@/components/calls/RejectCall';

export default {
  components: {
    CancelCall,
    RejectCall,
  },
  props: {
    headers: {
      type: Array,
      required: true,
    },
    actions: {
      type: Object,
      default() {
        return {
          cancel: false,
          request: false,
        }
      },
    },
  },
  data() {
    return {
      // eslint-disable-next-line global-require
      calls: [],
      currentPage: 1,
      totalRows: 10,
      activeCall: null,
    }
  },
  computed: {
    ...mapState({
      user: state => state.auth.user,
      filters: state => state.callList.filters,
    }),
  },
  watch: {
    currentPage() {
      this.getCalls();
    },
  },
  mounted() {
    this.getCalls();

    // listen for a custom android event
    window.addEventListener('callSearch', this.searchCalls);
  },
  beforeDestroy() {
    window.removeEventListener('callSearch', this.searchCalls);
  },
  methods: {
    searchCalls() {
      this.currentPage = 1;
      this.getCalls();
    },
    getCalls() {
      this.updateFilter('skip', (this.currentPage - 1) * this.filters.limit);

      VisitService.getVisits(this.filters).then(res => {
        this.loading = false;
        this.totalRows = res.data.count;

        // Add custom fields for table
        this.calls = res.data.data.map(call => {
          const requestedFor = getVisitRequestedDates(call);
          const bookedFor = getVisitBookedForDate(call);
          const slot = call.requested_booking_slot_1;
          const wing = (slot && slot.wing_name) ? slot.wing_name : '-';

          const callData = {
            ...call,
            prisonerNameAndNumber: `${call.prisoner.firstname} ${call.prisoner.lastname} (#${call.prisoner.prisoner_number})`,
            visitorName: `${call.visitor.firstname} ${call.visitor.lastname}`,
            wing,
            requestedFor1: requestedFor.requestedFor1,
            requestedFor2: requestedFor.requestedFor2,
            requestedForDate: requestedFor.requestedForDate,
            relationship: call.prisoner.relationship_to_booker,
            bookedFor: bookedFor.bookedFor,
            bookedBy: call.booked_by,
            bookedForDate: bookedFor.bookedForDate,
            reason: call.cancellation_reason,
            _rowVariant: call.external_cancellation ? 'danger' : '',
          };

          callData.external_cancellation = call.external_cancellation || false;
          return callData;
        });
      }).catch(err => {
        console.log('Error getting calls', err);
        this.$toast.error('Could not get calls, please refresh and try again', {
          toastClassName: ['toast-std', 'warning-toast'],
        });
      });
    },
    updateFilter(filterName, e, refresh) {
      this.$store.commit('callList/SET_FILTER_ITEM', { name: filterName, value: e });

      if (refresh) {
        this.searchCalls();
      }
    },
    showModal(name, value, call = null) {
      this.activeCall = call;
      if (value) {
        this.$bvModal.show(name);
      } else {
        this.$bvModal.hide(name);
      }
    },
    closeAllModalAndRefresh() {
      this.$bvModal.hide('modal-cancel');
      this.$bvModal.hide('modal-reject');
      this.getCalls();
    },
  },
}
</script>
